import Modal from 'react-bootstrap/Modal';
import {newEffectPreset, getEffectPresets} from 'decentralized/effects/EffectPresets.js';
import {EFFECT, ZOBJECT} from 'constants/object-types.js';
import {setShowLogin} from 'actions/index.js';
import accounts from 'accounts/Accounts.js';
import GuildOptions from './GuildOptions.js';
import PrivacyNote from './PrivacyNote.js';
import { Button } from 'reactstrap';
import PulseLoader from 'react-spinners/PulseLoader'
import EthereumExplanation from './EthereumExplanation.js';
import React, { Component } from 'react';
import axios from 'axios';
import {isNumber} from 'utils/IsNumber.js';
import MetamaskInstructions from './MetamaskInstructions.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import { connect } from "react-redux";
import {
    setShowModsModal,
    setContextualHelp,
    setTrackPresetSaving
} from 'actions/index.js';
import EffectMods from 'components/effects/EffectMods.js';
import {  InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';
import {PUBLIC_SAVE, PRIVATE_SAVE} from 'constants/contextual-help.js';
import {PUBLIC, PRIVATE, GUILD} from 'constants/save-sequence-options.js';
import '../../Modals.scss';
import ethereum from 'decentralized/ethereum.js';

/**
 * Modal responsible for sequence-wide changes like
 * double setting the track length
 */
class SavePresetModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            nameValue: '',
            isEffects: false,
            guildOptions: [],
            saveOption: PUBLIC,
            selectedGuild: undefined,
            guildIds: [],
        };

        this.input = undefined;

        this.onClickDone = this.onClickDone.bind(this);
        this.onClickCancel = this.onClickCancel.bind(this);
        console.log("PRESET CONS");
    }

    async getPresetGuilds() {
        /*
        console.log('getPresetGuilds');
        let track = this.props.sequencerEngine.tracks[this.props.trackNumber];
        let guildIds = await track.getGuildIds();
        console.log("get preset guilds returned = ", guildIds);
        this.setState({
            guildIds: guildIds
        });
        */
    }

    componentDidMount() {
        this.getGuilds();
        if (this.input) {
            this.input.focus();
        }
        this.getPresetGuilds();
    }

    async getGuilds() {
        let guilds = await ethereum.guilds.getGuildsForUser();
        if (this.props.selectedGuild !== undefined) {
            this.setState({
                saveOption: GUILD,
            });
        }
        this.setState({
            selectedGuild: this.props.selectedGuild,
            guildOptions: guilds.filter(x => x.name.split(',').length < 2)
        });
    }


    onSelectGuild(guild) {
        this.setState({
            selectedGuild: guild
        });
    }

    get selectedZObject() {
        let zobject = this.props.sequencerEngine.state.zobject.selectedZObject;
        let spatch = this.props.sequencerEngine.state.zobject.viewableSubPatches;

        let selectedZObject = zobject ||
            (spatch  &&
             spatch[0] && spatch[0].zObject);

        if (selectedZObject.getObjectType() !== ZOBJECT && selectedZObject.getObjectType() !== EFFECT) {
            selectedZObject = undefined;
        }
        return selectedZObject;
    }

    isZObject() {
        return this.selectedZObject !== undefined;
    }
    
    onClickDone() {
        // check if theres a zobject saved
        let selectedZObject = this.selectedZObject;

        if (selectedZObject) {
            // then we are saving a zobject
            if (selectedZObject.getObjectType() === EFFECT) {
                newEffectPreset(selectedZObject.getJson(true), this.state.nameValue);
            } else {
                this.props.sequencerEngine.saveZObjectPreset(selectedZObject, this.state.nameValue);
            }
        } else {
            this.props.sequencerEngine.saveTrackPreset(
                this.props.track.trackNumber,
                this.state.nameValue,
                this.state.isEffects,
                this.state.selectedGuild === undefined ? 0 :
                    this.state.selectedGuild.guildId);
        }
        this.props.onHide();
    }

    onClickCancel() {
        this.props.onHide();
    }

    onInputType(v) {
        this.setState({nameValue: v});
    }

    handleCheckboxChange(x) {
        this.setState({isEffects: x.target.name!=='track'});
    }

    login() {
        this.props.setShowLogin(true);
    }

    render() {
        if (!this.props.userToken) {
            return (
                <Modal dialogClassName="preset-modal" show={this.props.show} onHide={this.onClickCancel}>
                <Modal.Header closeButton>
                <Modal.Title>Save Preset</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <span onClick={() => this.login()} className="login-btn">Login</span> to save preset
                </Modal.Body>
                </Modal>);
        }
        let {selectedZObject} = this;
        return (
            <Modal dialogClassName="preset-modal" show={this.props.show} onHide={this.onClickCancel}>
              <Modal.Header closeButton>
                <Modal.Title>{selectedZObject ? "Save Object Preset (" + selectedZObject.name + ")" : "Save Preset"}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                 <input
                  value={this.state.nameValue}
                  onChange={(event) => this.onInputType(event.target.value)}
                  ref={(input) => { this.input = input; }} 
                  placeholder="Type name of preset"
                  className="tag-input"/>
                {!selectedZObject &&
                 <form>
                   <input
                     name="track"
                     type="checkbox"
                     checked={!this.state.isEffects}
                     onChange={(e) => this.handleCheckboxChange(e)} />
                   <label
                   >Track</label>
                   <input
                     name="effects"
                     type="checkbox"
                     checked={this.state.isEffects}
                     onChange={(e) => this.handleCheckboxChange(e)} />
                   <label
                   >Effects</label>
                 </form>}
                {/*
                <GuildOptions
                  showPublic={true}
                  onSelectGuild={(guild) => this.onSelectGuild(guild)}
                  selectedGuild={this.state.selectedGuild}
                  guildOptions={this.state.guildOptions}/>*/}
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={this.onClickDone}>
                  Save
                </Button>
                <Button variant="primary" onClick={this.onClickCancel}>
                  Cancel
                </Button>
              </Modal.Footer>
            </Modal>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setContextualHelp: (help) => dispatch(setContextualHelp(help)),
        setShowLogin: show=> dispatch(setShowLogin(show)),
        onHide: () => dispatch(setTrackPresetSaving(undefined))
    };
};
const mapStateToProps = state => {
    let track = state.presets.trackPresetSaving;
    return {
        userToken: state.sequencer.userToken,
        selectedGuild: state.guilds.selectedGuild,
        track,
        show: track
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(SavePresetModal);

